module.exports = __webpack_public_path__ + "static/media/naya_logo_symbol.7ae69fba.png";